import script from "./KPICards.vue?vue&type=script&setup=true&lang=js"
export * from "./KPICards.vue?vue&type=script&setup=true&lang=js"

import "./KPICards.vue?vue&type=style&index=0&id=805e0c5a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-805e0c5a"]])

export default __exports__